export const CONFIGURATION_BASE_PATH = "/config/v1";
export const CONFIGURATION_PRODUCT_QUERY = "product=Lighthouse%20Storage";
